import React from 'react';

import { defaultMerchant, platform } from '../constants/SiteVariables';
import { calculate_as_low_as_payment } from '../lib/utils'
import PromoImage from './shared/PromoImage';
import { isValidCharges, isValidPublicKey } from '../lib/validations'

export default function CheckoutDisplay({ match }) {
  const [total, shipping, tax, discount_amount, grand_total] = match.params.charges ? match.params.charges.split(',') : [0, 0, 0, 0, 0]

  if (isValidCharges(match.params.charges.split(',')) === false) {
    console.error("Invalid charges format. Please check that you have provided a valid charges object.")
    return (
      null
    )
  } else if (isValidPublicKey(match.params.public_key) === false) {
    console.error("Invalid public key. Please check that you have provided a valid public key.")
    return (
      null
    )
  } else {
    let calc = calculate_as_low_as_payment(grand_total ? grand_total : 0)

    return (
      <div role="checkout" className="ck-pdp">
        From ${calc}/month with <PromoImage /> <span className="prequal-link">Pay Now!</span>
        <div>
          <img alt="buy now text" className="buy-now" src="https://creditkey-assets.s3-us-west-2.amazonaws.com/ck-sub%402x.png" />
        </div>
      </div>
    )
  }
}
